export default __webpack_public_path__ + "locales/it/DeleteThirdPartyDialog.json?hash=9ef476093be66546be10d8445d2d5d69";